import React, { useEffect, useState } from 'react'
import Header from './Header'
import BackIcon from '../ui_icons/back.svg'
import { DEBOUNCE_DURATION } from '../helpers/constants'

export default function Stage({ message, flash, setStageView }) {
  // hideControls (boolean): when true, the header and footer should animate off
  // the screen to make additional room for the countdown timer. Set by a debounce
  // timer when the TimeDisplayView is on.
  const [hideControls, setHideControls] = useState(false)

  useEffect(() => {
    /*
      This useEffect handles the logic to dynamically hide
      the header and footer during countdown if the mouse
      hasn't moved for a bit.
    */

    function setDebounceTimer() {
      // initialize a timeout to hide controls
      // if time runs out without a mouse movement
      window.debounce_timer = window.setTimeout(
        () => setHideControls(true),
        DEBOUNCE_DURATION
      )
    }

    function clearDebounceTimer() {
      // clear any existing timeout that may have been running
      if (window.debounce_timer) {
        window.clearTimeout(window.debounce_timer)
      }
    }

    function handleMouseMove() {
      // on mouse move, show the controls,
      setHideControls(false)
      // clear any existing timeout,
      clearDebounceTimer()
      // and set a new one
      setDebounceTimer()
    }

    // set the timeout to hide controls
    setDebounceTimer()
    // create a mousemove event listener to reset the timeout
    window.addEventListener('mousemove', handleMouseMove)

    // the cleanup function will handle closing the mousemove event listener
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <>
      <Header hidden={hideControls} />
      <main id="stage" className={flash ? 'flashing' : null}>
        {message}
      </main>
      <footer>
        <button
          id="minimize-button"
          className={hideControls ? 'hidden' : null}
          onClick={() => setStageView(false)}
          data-mixpanel-component="dashboard-button"
        >
          <img src={BackIcon} alt="Minimize" /> View dashboard
        </button>
      </footer>
    </>
  )
}
